// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectionWrapper_XUnyf {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 20px;
}

.infoContainerWrapper_eD24w {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0; 
  justify-content: space-between;
}

.infoContainer_KnhKs {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;

  div {
    color: var(--_1f184b-color);
    font-size: 12px;
    font-weight: 500;
  }

  span {
    max-width: 360px;
    color: var(--_1f184b-color);
    font-size: 12px;
    font-weight: 300;
  }
}

.contentContainer_ijiiY {
  &.active_B60oI {
    display: block;
  }

  &.disabled_Kxgy6 {
    display: none;
  }
}

.contentInput_Q2lmW {
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
}

.titleContentInput_f7fF6 {
  color: var(--_1f184b-color);
  font-size: 13px;
  line-height: 1; 
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0px solid var(--e8-border);
  border-top: 0px solid var(--e8-border);
  margin-top: 0px;
  margin-bottom: 0px;

  .optionsContentInput__638V {
    display: flex;
    align-items: center;
    gap: 10px;

  }
}

.titleContentInputFromRulesFilter_KSXFD {
  color: var(--_1f184b-color);
  font-size: 18px;
  line-height: 1;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;

  .optionsContentInput__638V {
    display: flex;
    align-items: center;
    gap: 10px;

  }
}

.cardTypesContainer_TNv0g {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 9px 0;
}

.singleTypeCard_WUxz5 {
  display: flex;
  gap: 9px;
  padding: 3px 12px;
  border-radius: 30px;
  border: 1px solid var(--e0e3e6-border);

  span {
    font-size: 12px;
    font-weight: 400;
    color: var(--_2a2e32-color);
    -webkit-user-select: none;
            user-select: none;
  }
}

.minusIcon_c3kZl {
  height: 13px;
  margin-top: 1px;
  width: 13px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 50%;
  background: var(--dc3545-background);
  display: flex;
  align-items: center;
  justify-content: center;
}


.subtitleContentInput_rfawm {
  font-weight: 300;
  font-size: 11;
  color: var(--_18181b-color);
}

.quantityContainer_mhQD8 {
  display: flex;
  gap: 10px;
  align-items: center;

  .quantityContent_qBKq_ {
    gap: 10px;
    flex: 1 1;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    color: var(--_1e0045-color);

    input {
      background-color: var(--f5-background);
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      border-radius: 4px;
      padding: 0px 18px;
      font-family: "Inter", sans-serif;
      border: none;
      outline: none;
    }
  }

  p {
    margin: 0;
    height: fit-content;
  }
}

.currencyContainer_XiNqw {
  color: var(--_ var(--_264f88-color)-color);
  font-weight: bold;
  border-bottom: 2px solid var(--_ var(--_264f88-color)-border);
  gap: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;

  div {
    gap: 5px;
  }
}

.currencyDropdownButton_KMZ1G {
  display: flex;
  gap: 5px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}

.chevronIcon_yAaMM {
  margin-top: 3px;
}

.currencyDropdown_cn3Et {
  position: absolute;
  top: 97%;
  left: -4%;
  width: 108%;
  display: flex;
  flex-direction: column;
  background-color: var(--f4-background);
  border-radius: 4px;
  color: var(--_264f88-color);
  font-size: 14px;
  box-shadow: 0 2px 4px var(--_0000001a-shadow);
  z-index: 1;
  overflow: hidden;

  span {
    display: flex;
    padding: 1px 2px;
    align-items: center;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    justify-content: flex-start;

    &:hover {
      background-color: var(--ececf1-background);
    }
  }
}

.conditionsContainer_CwM8b {
  display: flex;
  padding: 5px 9px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 10px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--f4-background);

  .conditions_tjg2x {
    display: flex;
    width: 100%;
    gap: 4px 10px;
    flex-wrap: wrap;

    .condition_a5IXL {
      display: flex;
      padding: 6px 12px;
      align-items: center;
      gap: 8px;
      border-radius: 30px;
      border: 1px solid var(--e0e3e6-border);
      background: var(--white-background);
      -webkit-border-radius: 30px;
      -moz-border-radius: 30px;
      -ms-border-radius: 30px;
      -o-border-radius: 30px;
      color: var(--_2a2e32-color);
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      overflow: hidden;

      textarea,
      input,
      span {
        font-family: "Inter", sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        overflow: hidden;
        border: none;
        padding: 0;
      }
    }

    .conditionInput_TlU0M {
      outline: none;
      border: none;
      resize: none;
      field-sizing: content;
    }
  }

  input {
    background-color: transparent;
    border: none;
    outline: none;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    box-sizing: border-box;

    &::placeholder {
      color: var(--_71717a-color);
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
    }
  }
}

.hasTooltip_NsTII {
  &::before {
    content: attr(data-tooltip);
    position: absolute;
    top: calc(120% - 8px);
    left: 50%;
    transform: translateX(-50%);
    padding: 5px 10px;
    background: var(--_000000cc-background);
    color: var(--white-color);
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    z-index: 99999;
    white-space: pre-line;
    text-align: center;
    line-height: 20px;

    max-width: 200px;
    overflow-wrap: break-word;

    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &::after {
    content: "";
    position: absolute;
    top: calc(100% - 10px);
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-bottom-color: var(--_000000cc-background);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    z-index: 99999;

  }

  &:hover::before,
  &:hover::after {
    opacity: 1;
    visibility: visible;
  }
}

.labelName_hiMgJ {
  position: relative;

}

.labelName_hiMgJ input {
  display: flex;
  height: 32px;
  padding: 6px 8px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0;
  border-radius: 4px;
  outline: none;
  border: none;
  color: var(--black-color);
  font-size: 14px;
  font-weight: 400;

  &::placeholder {
    color: var(--black-color);
  }


}

.labelName_hiMgJ input:not([disabled]) {
  background-color: var(--f4-background);
  border-radius: 5px;
  box-sizing: border-box;
  width: 100%;
  padding: 12px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

.filtersLabelOptions_GLKOy {
  border-left: 1px solid var(--c3-border);
  display: flex;
  padding-left: 12px;
  margin-left: 10px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  p {
    margin: 5px;
  }
}



.changeTypeContainerButton_smnvK {
  display: flex;
  width: 100%;
  display: flex;
  height: 50px;
  padding: 6px 5px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  background: var(--f9-background);

  >button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0;
    border-radius: 8px;
    box-shadow:
      0px 0px 2px 0px var(--_00000008-shadow),
      0px 0px 0px 0px var(--_00000000-shadow) 0px 0px 0px 0px var(--_00000000-shadow);
    background-color: transparent;
    outline: none;
    border: 1px solid transparent;
    color: var(--_b4-color);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }

  .typeFilterBtn_EgHnU {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0;
    border-radius: 8px;
    border: 1px solid var(--_0000001a-border);
    background: var(--white-background);
    box-shadow:
      0px 0px 2px 0px var(--_00000008-shadow),
      0px 0px 0px 0px var(--_00000000-shadow) 0px 0px 0px 0px var(--_00000000-shadow);
    color: var(--_0d-color);
  }
}

.buttonAddFilter_tp_Qa {
  display: flex;
  height: fit-content;
  padding: 14px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid var(--cb-border);
  background: var(--white-background);
  cursor: pointer;
  flex: 1 1;
  box-sizing: border-box;
  width: 100%;
}



.keywordContainer_cwQHs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 4px 0;

  .keyword_HGjzi {
    display: flex;
    gap: 9px;
    padding: 3px 12px;
    border-radius: 30px;
    border: 1px solid var(--e0e3e6-border);
    align-items: center;
  }
}

.buttonsTypeConditionAbsolute_q0Jv3 {
  display: flex;
  width: 70px;
  height: 28px;
  box-sizing: border-box;
  margin-top: 15px;
  /* position: absolute; */
  right: 5px;
  top: -5px;
  cursor: pointer;
  border-radius: 99px;
  border: 1px solid var(--cb-border);
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: var(--white-background);
}



.labelNameFromRulesFilter_KA_cZ {
  width: 100%;
}

.labelNameFromRulesFilter_KA_cZ input {
  display: flex;
  height: 32px;
  padding: 6px 8px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0;
  border-radius: 4px;
  outline: none;
  border: none;
  color: var(--black-color);
  font-size: 14px;
  font-weight: 400;

  &::placeholder {
    color: var(--black-color);
  }
}

.labelNameFromRulesFilter_KA_cZ input:not([disabled]) {
  background-color: var(--f4-background);
  border-radius: 5px;
  box-sizing: border-box;
  width: 100%;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  padding: 8px;
  box-sizing: border-box;
}

.buttonsAddFilter_QCZBn {
  display: flex;
  gap: 10px;
  width: 100%;
}

.buttonsCameraContainer_txlBt {
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: end;
  align-items: center;

  >div {
    cursor: pointer;
    background: var(--_10a37f-background);
    width: 30px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
}

.buttonAplyFilter_m01T2 {
  display: flex;
  height: fit-content;
  padding: 14px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 0px solid var(--cb-border);
  background: var(--_10a37f-background);
  cursor: pointer;
  flex: 1 1;
  box-sizing: border-box;
  width: 100%;
  color: var(--white-color);
}

.buttonsAddFilter_QCZBn {
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: end;
}

.buttonRetry_o46O8 {
  display: flex;
  height: fit-content;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 0px solid var(--cb-border);
  background: transparent;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
  line-height: 21px;
  color: var(--_63-color);
  cursor: pointer;
}

.buttonRetry_o46O8:hover {
  background-color: var(--e6-background);
}

.descriptionInput_YfyOY {
  width: 535px;
  height: 100%;
  border: 1px solid var(--e0-border);
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 5px;
  outline: none;

  width: 100%;
  min-height: 60px;
  resize: none;
  overflow: hidden;
  box-sizing: border-box;
  font-family: inherit;
}

    
.labelContainer_BixPW {
  display: flex;
  flex-direction: column;
  background: var(--white-background);
  padding: 10px;
  margin: 8px 0;
  border-radius: 5px;
  box-shadow: 0 2px 5px var(--_00000033-shadow);
  transition: background 0.2s ease;
}

.labelContainer_BixPW:hover {
  background: var(--f8f9fa-background);
}



.loaderGenerar_xqgHK {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: relative;
  animation: rotate_JspiP 1s linear infinite
}

.loaderGenerar_xqgHK::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0px;
  border-radius: 50%;
  border: 5px solid var(--white-border);
  animation: prixClipFix_qz7JB 2s linear infinite;
}

.inputPath_xWAa6 {
  background-color: transparent;
  border: none;
  width: 100%;
  height: 32px;
  color: var(--_1e0045-color);
  font-weight: 300;
  padding: 0px;
  font-size: 13px;
  outline: none;

  &::placeholder {
    color: var(--_71717a-color);
  }
}

.inputContainer_RGCAN {
  background-color: var(--f5-background);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  border-radius: 4px;
  padding: 0px 18px;
  font-family: "Inter", sans-serif;
}

@keyframes rotate_JspiP {
  100% {
    transform: rotate(360deg)
  }
}

@keyframes prixClipFix_qz7JB {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0)
  }

  25% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0)
  }

  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%)
  }

  75% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%)
  }

  100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0)
  }
}

.wrapper_JSsD4 {
  position: relative;
  width: 100%;
  max-width: 500px;
}


.counter_R752a {
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 12px;
  color: var(--_6-color);
  background-color: var(--white-color);
  padding: 2px 4px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/FiltersAndVariablesOut/FiltersAndVariablesOut2.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;;EAEV;IACE,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;EACzC,sCAAsC;EACtC,eAAe;EACf,kBAAkB;;EAElB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;EAEX;AACF;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;;EAEd;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;EAEX;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;;EAEtC;IACE,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAiB;YAAjB,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;;EAEnB;IACE,SAAS;IACT,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;;IAE3B;MACE,sCAAsC;MACtC,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,YAAY;MACZ,kBAAkB;MAClB,iBAAiB;MACjB,gCAAgC;MAChC,YAAY;MACZ,aAAa;IACf;EACF;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;AACF;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,6DAA6D;EAC7D,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;;EAElB;IACE,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,6CAA6C;EAC7C,UAAU;EACV,gBAAgB;;EAEhB;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,2BAA2B;;IAE3B;MACE,0CAA0C;IAC5C;EACF;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;;EAEhC;IACE,aAAa;IACb,WAAW;IACX,aAAa;IACb,eAAe;;IAEf;MACE,aAAa;MACb,iBAAiB;MACjB,mBAAmB;MACnB,QAAQ;MACR,mBAAmB;MACnB,sCAAsC;MACtC,mCAAmC;MACnC,2BAA2B;MAC3B,wBAAwB;MACxB,uBAAuB;MACvB,sBAAsB;MACtB,2BAA2B;MAC3B,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;;MAEhB;;;QAGE,gCAAgC;QAChC,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,UAAU;MACZ;IACF;;IAEA;MACE,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,qBAAqB;IACvB;EACF;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;;IAEtB;MACE,2BAA2B;MAC3B,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,uCAAuC;IACvC,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;;IAEjB,gBAAgB;IAChB,yBAAyB;;IAEzB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,2BAA2B;IAC3B,6BAA6B;IAC7B,gDAAgD;IAChD,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;;EAEhB;;EAEA;;IAEE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;;EAEhB;IACE,yBAAyB;EAC3B;;;AAGF;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;;EAEnB;IACE,WAAW;EACb;AACF;;;;AAIA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;;EAEhC;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,SAAW;IACX,kBAAkB;IAClB;;qFAEiF;IACjF,6BAA6B;IAC7B,aAAa;IACb,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,SAAW;IACX,kBAAkB;IAClB,yCAAyC;IACzC,mCAAmC;IACnC;;qFAEiF;IACjF,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,eAAe;EACf,SAAO;EACP,sBAAsB;EACtB,WAAW;AACb;;;;AAIA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;;EAEb;IACE,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,sCAAsC;IACtC,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;;;AAIA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;;EAEhB;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;;EAEnB;IACE,eAAe;IACf,qCAAqC;IACrC,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;;IAElB;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,qCAAqC;EACrC,eAAe;EACf,SAAO;EACP,sBAAsB;EACtB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,aAAa;;EAEb,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,qCAAqC;EACrC,+CAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;;EAEb;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;AAClB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n.sectionWrapper {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0; \n  justify-content: space-between;\n}\n\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n\n  div {\n    color: var(--_1f184b-color);\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  span {\n    max-width: 360px;\n    color: var(--_1f184b-color);\n    font-size: 12px;\n    font-weight: 300;\n  }\n}\n\n.contentContainer {\n  &.active {\n    display: block;\n  }\n\n  &.disabled {\n    display: none;\n  }\n}\n\n.contentInput {\n  margin-bottom: 14px;\n  display: flex;\n  flex-direction: column;\n}\n\n.titleContentInput {\n  color: var(--_1f184b-color);\n  font-size: 13px;\n  line-height: 1; \n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 0px solid var(--e8-border);\n  border-top: 0px solid var(--e8-border);\n  margin-top: 0px;\n  margin-bottom: 0px;\n\n  .optionsContentInput {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n  }\n}\n\n.titleContentInputFromRulesFilter {\n  color: var(--_1f184b-color);\n  font-size: 18px;\n  line-height: 1;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 10px 0;\n\n  .optionsContentInput {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n  }\n}\n\n.cardTypesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 9px 0;\n}\n\n.singleTypeCard {\n  display: flex;\n  gap: 9px;\n  padding: 3px 12px;\n  border-radius: 30px;\n  border: 1px solid var(--e0e3e6-border);\n\n  span {\n    font-size: 12px;\n    font-weight: 400;\n    color: var(--_2a2e32-color);\n    user-select: none;\n  }\n}\n\n.minusIcon {\n  height: 13px;\n  margin-top: 1px;\n  width: 13px;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 50%;\n  background: var(--dc3545-background);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.subtitleContentInput {\n  font-weight: 300;\n  font-size: 11;\n  color: var(--_18181b-color);\n}\n\n.quantityContainer {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n\n  .quantityContent {\n    gap: 10px;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    color: var(--_1e0045-color);\n\n    input {\n      background-color: var(--f5-background);\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      height: 32px;\n      border-radius: 4px;\n      padding: 0px 18px;\n      font-family: \"Inter\", sans-serif;\n      border: none;\n      outline: none;\n    }\n  }\n\n  p {\n    margin: 0;\n    height: fit-content;\n  }\n}\n\n.currencyContainer {\n  color: var(--_ var(--_264f88-color)-color);\n  font-weight: bold;\n  border-bottom: 2px solid var(--_ var(--_264f88-color)-border);\n  gap: 5px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n\n  div {\n    gap: 5px;\n  }\n}\n\n.currencyDropdownButton {\n  display: flex;\n  gap: 5px;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n}\n\n.chevronIcon {\n  margin-top: 3px;\n}\n\n.currencyDropdown {\n  position: absolute;\n  top: 97%;\n  left: -4%;\n  width: 108%;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--f4-background);\n  border-radius: 4px;\n  color: var(--_264f88-color);\n  font-size: 14px;\n  box-shadow: 0 2px 4px var(--_0000001a-shadow);\n  z-index: 1;\n  overflow: hidden;\n\n  span {\n    display: flex;\n    padding: 1px 2px;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n    justify-content: flex-start;\n\n    &:hover {\n      background-color: var(--ececf1-background);\n    }\n  }\n}\n\n.conditionsContainer {\n  display: flex;\n  padding: 5px 9px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 10px;\n  align-self: stretch;\n  border-radius: 5px;\n  background: var(--f4-background);\n\n  .conditions {\n    display: flex;\n    width: 100%;\n    gap: 4px 10px;\n    flex-wrap: wrap;\n\n    .condition {\n      display: flex;\n      padding: 6px 12px;\n      align-items: center;\n      gap: 8px;\n      border-radius: 30px;\n      border: 1px solid var(--e0e3e6-border);\n      background: var(--white-background);\n      -webkit-border-radius: 30px;\n      -moz-border-radius: 30px;\n      -ms-border-radius: 30px;\n      -o-border-radius: 30px;\n      color: var(--_2a2e32-color);\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 20px;\n      overflow: hidden;\n\n      textarea,\n      input,\n      span {\n        font-family: \"Inter\", sans-serif;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 20px;\n        overflow: hidden;\n        border: none;\n        padding: 0;\n      }\n    }\n\n    .conditionInput {\n      outline: none;\n      border: none;\n      resize: none;\n      field-sizing: content;\n    }\n  }\n\n  input {\n    background-color: transparent;\n    border: none;\n    outline: none;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 21px;\n    box-sizing: border-box;\n\n    &::placeholder {\n      color: var(--_71717a-color);\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 21px;\n    }\n  }\n}\n\n.hasTooltip {\n  &::before {\n    content: attr(data-tooltip);\n    position: absolute;\n    top: calc(120% - 8px);\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 5px 10px;\n    background: var(--_000000cc-background);\n    color: var(--white-color);\n    border-radius: 4px;\n    font-size: 12px;\n    white-space: nowrap;\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease;\n    z-index: 99999;\n    white-space: pre-line;\n    text-align: center;\n    line-height: 20px;\n\n    max-width: 200px;\n    overflow-wrap: break-word;\n\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    top: calc(100% - 10px);\n    left: 50%;\n    transform: translateX(-50%);\n    border: 5px solid transparent;\n    border-bottom-color: var(--_000000cc-background);\n    opacity: 0;\n    visibility: hidden;\n    transition: all 0.3s ease;\n    z-index: 99999;\n\n  }\n\n  &:hover::before,\n  &:hover::after {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n.labelName {\n  position: relative;\n\n}\n\n.labelName input {\n  display: flex;\n  height: 32px;\n  padding: 6px 8px;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1 0 0;\n  border-radius: 4px;\n  outline: none;\n  border: none;\n  color: var(--black-color);\n  font-size: 14px;\n  font-weight: 400;\n\n  &::placeholder {\n    color: var(--black-color);\n  }\n\n\n}\n\n.labelName input:not([disabled]) {\n  background-color: var(--f4-background);\n  border-radius: 5px;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n}\n\n.filtersLabelOptions {\n  border-left: 1px solid var(--c3-border);\n  display: flex;\n  padding-left: 12px;\n  margin-left: 10px;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n\n  p {\n    margin: 5px;\n  }\n}\n\n\n\n.changeTypeContainerButton {\n  display: flex;\n  width: 100%;\n  display: flex;\n  height: 50px;\n  padding: 6px 5px;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n  border-radius: 12px;\n  background: var(--f9-background);\n\n  >button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    flex: 1 0 0;\n    border-radius: 8px;\n    box-shadow:\n      0px 0px 2px 0px var(--_00000008-shadow),\n      0px 0px 0px 0px var(--_00000000-shadow) 0px 0px 0px 0px var(--_00000000-shadow);\n    background-color: transparent;\n    outline: none;\n    border: 1px solid transparent;\n    color: var(--_b4-color);\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n  }\n\n  .typeFilterBtn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    flex: 1 0 0;\n    border-radius: 8px;\n    border: 1px solid var(--_0000001a-border);\n    background: var(--white-background);\n    box-shadow:\n      0px 0px 2px 0px var(--_00000008-shadow),\n      0px 0px 0px 0px var(--_00000000-shadow) 0px 0px 0px 0px var(--_00000000-shadow);\n    color: var(--_0d-color);\n  }\n}\n\n.buttonAddFilter {\n  display: flex;\n  height: fit-content;\n  padding: 14px 24px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  border: 1px solid var(--cb-border);\n  background: var(--white-background);\n  cursor: pointer;\n  flex: 1;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n\n\n.keywordContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 4px 0;\n\n  .keyword {\n    display: flex;\n    gap: 9px;\n    padding: 3px 12px;\n    border-radius: 30px;\n    border: 1px solid var(--e0e3e6-border);\n    align-items: center;\n  }\n}\n\n.buttonsTypeConditionAbsolute {\n  display: flex;\n  width: 70px;\n  height: 28px;\n  box-sizing: border-box;\n  margin-top: 15px;\n  /* position: absolute; */\n  right: 5px;\n  top: -5px;\n  cursor: pointer;\n  border-radius: 99px;\n  border: 1px solid var(--cb-border);\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  background-color: var(--white-background);\n}\n\n\n\n.labelNameFromRulesFilter {\n  width: 100%;\n}\n\n.labelNameFromRulesFilter input {\n  display: flex;\n  height: 32px;\n  padding: 6px 8px;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1 0 0;\n  border-radius: 4px;\n  outline: none;\n  border: none;\n  color: var(--black-color);\n  font-size: 14px;\n  font-weight: 400;\n\n  &::placeholder {\n    color: var(--black-color);\n  }\n}\n\n.labelNameFromRulesFilter input:not([disabled]) {\n  background-color: var(--f4-background);\n  border-radius: 5px;\n  box-sizing: border-box;\n  width: 100%;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.buttonsAddFilter {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n}\n\n.buttonsCameraContainer {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n  justify-content: end;\n  align-items: center;\n\n  >div {\n    cursor: pointer;\n    background: var(--_10a37f-background);\n    width: 30px;\n    height: 30px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n\n    svg {\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n.buttonAplyFilter {\n  display: flex;\n  height: fit-content;\n  padding: 14px 24px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  border: 0px solid var(--cb-border);\n  background: var(--_10a37f-background);\n  cursor: pointer;\n  flex: 1;\n  box-sizing: border-box;\n  width: 100%;\n  color: var(--white-color);\n}\n\n.buttonsAddFilter {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n  justify-content: end;\n}\n\n.buttonRetry {\n  display: flex;\n  height: fit-content;\n  padding: 10px 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  border: 0px solid var(--cb-border);\n  background: transparent;\n  font-size: 14px;\n  font-family: Roboto;\n  font-weight: 400;\n  line-height: 21px;\n  color: var(--_63-color);\n  cursor: pointer;\n}\n\n.buttonRetry:hover {\n  background-color: var(--e6-background);\n}\n\n.descriptionInput {\n  width: 535px;\n  height: 100%;\n  border: 1px solid var(--e0-border);\n  border-radius: 4px;\n  padding: 10px;\n  margin-bottom: 5px;\n  outline: none;\n\n  width: 100%;\n  min-height: 60px;\n  resize: none;\n  overflow: hidden;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n    \n.labelContainer {\n  display: flex;\n  flex-direction: column;\n  background: var(--white-background);\n  padding: 10px;\n  margin: 8px 0;\n  border-radius: 5px;\n  box-shadow: 0 2px 5px var(--_00000033-shadow);\n  transition: background 0.2s ease;\n}\n\n.labelContainer:hover {\n  background: var(--f8f9fa-background);\n}\n\n\n\n.loaderGenerar {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  position: relative;\n  animation: rotate 1s linear infinite\n}\n\n.loaderGenerar::before {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  inset: 0px;\n  border-radius: 50%;\n  border: 5px solid var(--white-border);\n  animation: prixClipFix 2s linear infinite;\n}\n\n.inputPath {\n  background-color: transparent;\n  border: none;\n  width: 100%;\n  height: 32px;\n  color: var(--_1e0045-color);\n  font-weight: 300;\n  padding: 0px;\n  font-size: 13px;\n  outline: none;\n\n  &::placeholder {\n    color: var(--_71717a-color);\n  }\n}\n\n.inputContainer {\n  background-color: var(--f5-background);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 32px;\n  border-radius: 4px;\n  padding: 0px 18px;\n  font-family: \"Inter\", sans-serif;\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg)\n  }\n}\n\n@keyframes prixClipFix {\n  0% {\n    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0)\n  }\n\n  25% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0)\n  }\n\n  50% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%)\n  }\n\n  75% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%)\n  }\n\n  100% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0)\n  }\n}\n\n.wrapper {\n  position: relative;\n  width: 100%;\n  max-width: 500px;\n}\n\n\n.counter {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  font-size: 12px;\n  color: var(--_6-color);\n  background-color: var(--white-color);\n  padding: 2px 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionWrapper": `sectionWrapper_XUnyf`,
	"infoContainerWrapper": `infoContainerWrapper_eD24w`,
	"infoContainer": `infoContainer_KnhKs`,
	"contentContainer": `contentContainer_ijiiY`,
	"active": `active_B60oI`,
	"disabled": `disabled_Kxgy6`,
	"contentInput": `contentInput_Q2lmW`,
	"titleContentInput": `titleContentInput_f7fF6`,
	"optionsContentInput": `optionsContentInput__638V`,
	"titleContentInputFromRulesFilter": `titleContentInputFromRulesFilter_KSXFD`,
	"cardTypesContainer": `cardTypesContainer_TNv0g`,
	"singleTypeCard": `singleTypeCard_WUxz5`,
	"minusIcon": `minusIcon_c3kZl`,
	"subtitleContentInput": `subtitleContentInput_rfawm`,
	"quantityContainer": `quantityContainer_mhQD8`,
	"quantityContent": `quantityContent_qBKq_`,
	"currencyContainer": `currencyContainer_XiNqw`,
	"currencyDropdownButton": `currencyDropdownButton_KMZ1G`,
	"chevronIcon": `chevronIcon_yAaMM`,
	"currencyDropdown": `currencyDropdown_cn3Et`,
	"conditionsContainer": `conditionsContainer_CwM8b`,
	"conditions": `conditions_tjg2x`,
	"condition": `condition_a5IXL`,
	"conditionInput": `conditionInput_TlU0M`,
	"hasTooltip": `hasTooltip_NsTII`,
	"labelName": `labelName_hiMgJ`,
	"filtersLabelOptions": `filtersLabelOptions_GLKOy`,
	"changeTypeContainerButton": `changeTypeContainerButton_smnvK`,
	"typeFilterBtn": `typeFilterBtn_EgHnU`,
	"buttonAddFilter": `buttonAddFilter_tp_Qa`,
	"keywordContainer": `keywordContainer_cwQHs`,
	"keyword": `keyword_HGjzi`,
	"buttonsTypeConditionAbsolute": `buttonsTypeConditionAbsolute_q0Jv3`,
	"labelNameFromRulesFilter": `labelNameFromRulesFilter_KA_cZ`,
	"buttonsAddFilter": `buttonsAddFilter_QCZBn`,
	"buttonsCameraContainer": `buttonsCameraContainer_txlBt`,
	"buttonAplyFilter": `buttonAplyFilter_m01T2`,
	"buttonRetry": `buttonRetry_o46O8`,
	"descriptionInput": `descriptionInput_YfyOY`,
	"labelContainer": `labelContainer_BixPW`,
	"loaderGenerar": `loaderGenerar_xqgHK`,
	"rotate": `rotate_JspiP`,
	"prixClipFix": `prixClipFix_qz7JB`,
	"inputPath": `inputPath_xWAa6`,
	"inputContainer": `inputContainer_RGCAN`,
	"wrapper": `wrapper_JSsD4`,
	"counter": `counter_R752a`
};
export default ___CSS_LOADER_EXPORT___;
